import { ColumnFiltersState } from '@tanstack/react-table';

/**
 * Превращает список фильтров в объект:
 * { columnId: value },
 * отбрасывая пустые значения
 *
 * @example
 * filtersToMap([
 *   { id: 'status', value: 'active' },
 *   { id: 'title', value: '' },
 * ]);
 * result: { status: 'active' }
 */
export const filtersToMap = (list: ColumnFiltersState) => {
	const map: Record<string, unknown> = {};
	list.forEach((el) => {
		if (el.value) {
			map[el.id] = el.value;
		}
	});
	return map;
};
